<template>
  <v-container fluid>
    <material-card
      color="primary"
      title="Notifikasi"
      class="card-wrapper"
    >
      <form>
        <div style="height: 80px" class="form-input row">
          <div class="col-4">
            <p class="label font-weight-bold mb-1">Status Notifikasi</p>
            <v-select
              :items="isReadOptions"
              :item-text="item => item.text"
              :item-value="item => item.value"
              no-data-text="Tidak ada data"
              placeholder="Pilih Status Notifikasi"
              clearable
              dense
              outlined
              v-model="isRead"
              @keydown.enter.prevent
            ></v-select>
          </div>
          <div class="col-4">
            <p class="label font-weight-bold mb-1"><br></p>
            <v-btn
              color="primary"
              class="mr-4"
              block
              elevation="2"
              @click="searchNotification()"
            >
              Cari
            </v-btn>
          </div>
        </div>
        <br>
      </form>
      <v-card>
        <div class="col-8">
          <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari di tabel"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
        </div>
  
        <v-data-table
          :headers="headers"
          :search="search"
          :items="items"
          no-results-text="Data tidak ditemukan"
          no-data-text="Tidak ada notifikasi"
          class="elevation-1"
          :loading="isLoading"
          loading-text="Memuat data..."
          :options.sync="options"
          hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            >
              <v-btn small color="primary" @click="markAllRead">Mark All Read</v-btn>
            </esign-table-footer>
          </template>
          <template
            v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip
              small
              dark
              :color="(typeConfig[item.type] && typeConfig[item.type].color) || 'grey'"
            >
              <v-icon left small>
                {{ (typeConfig[item.type] && typeConfig[item.type].icon) || 'mdi-bell' }}
              </v-icon>

              {{ formatType(item.type) }}
            </v-chip>
          </template>
          <template v-slot:item.is_read="{ item }">
            <esign-status-tag :tone="item.is_read ? 'neutral' : 'danger'">
              {{ item.is_read ? "Read" : "Unread" }}
            </esign-status-tag>
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ formatDate(item.created_at) }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-row>
              <v-btn
                v-if="!item.is_read"
                small
                color="primary"
                dark
                @click="markRead(item)"
              >
                Mark As Read
              </v-btn>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </material-card>
  </v-container>
</template>

<script>
import Paginate from 'vuejs-paginate';
import { getNotifications, markAllReadNotifications, markAsReadNotification } from "@/services/NotificationService";

export default {
data: () => ({
  items: [],
  isLoading: false,
  search: "",
  totalData: 0,
  isRead: null,
  typeConfig: {
    TTD_SUCCESS: {
      color: 'success',
      icon: 'mdi-check-circle'
    },
    TTD_FAILED: {
      color: 'error',
      icon: 'mdi-close-circle'
    },
    TTD_PROCESSING: {
      color: 'info',
      icon: 'mdi-sync'
    }
  },
  isReadOptions: [
    { text: "Unread", value: false },
    { text: "Read", value: true }
  ],
  snackbar:false,
  snackbarText:"",
  snackbarColor:"",
  headers: [
    { text:"Type", value:"type"},
    { text:"Message", value:"message"},
    { text:"Status", value:"is_read"},
    { text:"Tanggal", value:"created_at"},
    { text: "Aksi", align:"center", value: "action", sortable: false}
  ],
}),
components: {
  Paginate
},
computed: {
},
watch: {
  options: {
    handler() {
      this.getData()
    },
    deep: true
  },
},

created() {
  this.peran = localStorage.getItem("currentPeran")
  this.user = JSON.parse(localStorage.getItem("user"))
  if (this.$store.state.snackbar.snackbarText != null) {
    this.showMessage()
  }
},
  mounted(){
    this.getData();
  },
methods: {
  formatType(type) {
    return type
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, l => l.toUpperCase())
  },
  formatDate(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  },
  async getData() {
    this.isLoading = true;
    try {
      const res = await getNotifications(this.isRead);
      this.items = res.data
      this.totalData = this.items.length
    } catch (err) {
      this.showSnackbar("error","Gagal ambil notifikasi")
    } finally {
      this.isLoading = false;
    }
  },
  showSnackbar(color, message) {
    this.snackbar = true;
    this.snackbarText = message;
    this.snackbarColor = color;
  },
  showMessage () {
    this.showSnackbar(
        this.$store.state.snackbar.snackbarColor,
        this.$store.state.snackbar.snackbarText
    )
    this.$store.dispatch('setSnackbar', {
      snackbarColor: null,
      snackbarText: null,
    })
  },
  searchNotification(){
    this.options.page = 1
    this.getDataSource = "search"
    this.getData()
  },
  async markAllRead(){
    try{
      await markAllReadNotifications()
      this.showSnackbar("success","Semua notifikasi sudah dibaca")
      this.getData()
    } catch(err){
      this.showSnackbar("error","Gagal mark notifikasi")
    }
  },
  async markRead(item){
    try{
      await markAsReadNotification(item.id)
      this.showSnackbar("success","Notifikasi sudah dibaca")
      this.getData()
    } catch(err){
      this.showSnackbar("error","Gagal mark notifikasi")
    }
  },
}
};
</script>